/**
 * Registration flow steps.
 * Flow: phone -> existing-confirm (if found) -> form -> register
 */
export enum E_RegistrationStep {
  PHONE = 'phone',
  EXISTING_CONFIRM = 'existing-confirm',
  FORM = 'form',
}

export type T_RegistrationStep = E_RegistrationStep;
